export const dataDateOfEntry = {
  type: 'string',
  minLength: 1,
};
